export const stepsTypes = Object.freeze({
  SET_REF_FOR_STEP: 'SET_REF_FOR_STEP',
  SET_ACTIVE_STEP: 'SET_ACTIVE_STEP'
})
